export const CustomerApplogin = "/customer/customer-login";
export const Customer_App_Shift = "/shift/view-shift-by-user";
